var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.10--Elements",
    transform: "translate(-1115.000000, -698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1115.000000, 698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    fill: "#F86B67"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.93909247,7.99943157 L11.8029915,5.14178673 C12.0641539,4.88058722 12.0641539,4.45709914 11.8029915,4.19589963 C11.5418291,3.93470012 11.1184012,3.93470012 10.8572388,4.19589963 L8,7.06020565 L5.1427612,4.19589963 C4.8815988,3.93470013 4.4581709,3.93470013 4.1970085,4.19589964 C3.93584611,4.45709915 3.93584611,4.88058722 4.1970085,5.14178673 L7.06090753,7.99943157 L4.1970085,10.8570764 C4.07092191,10.9821511 4,11.152408 4,11.33002 C4,11.5076319 4.07092191,11.6778889 4.1970085,11.8029635 C4.32206538,11.929068 4.49229811,12 4.66988485,12 C4.84747159,12 5.01770432,11.929068 5.1427612,11.8029635 L8,8.9386575 L10.8572388,11.8029635 C10.9822957,11.929068 11.1525284,12 11.3301152,12 C11.5077019,12 11.6779346,11.929068 11.8029915,11.8029635 C11.9290781,11.6778889 12,11.5076319 12,11.33002 C12,11.152408 11.9290781,10.9821511 11.8029915,10.8570764 L8.93909247,7.99943157 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.6fdb77e9641a2299f01b8cad84058d91.svg";
export { ForwardRef as ReactComponent };